import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PurchaseOrderComment } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0620. 発注案件コメント一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const purchaseOrderComments = (props: Props): Promise<PurchaseOrderComment[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/purchase_order_comments`);
};

export const usePurchaseOrderComments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => purchaseOrderComments(props),
  });
};

export const usePurchaseOrderCommentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.id, 'purchase_order_comments'];
};
